import React from 'react';

import { cn } from '@/lib/utils';
import { agentIcon } from '../agents';

/**
 * An agent's face: a grey line glyph in a rounded square.
 *
 * Neutral on purpose — colour on this surface is kept for meaning, and an
 * agent's identity is not one. What does carry meaning is whether it is
 * working, which is a small live dot on the corner rather than a tint.
 */
export const AgentAvatar: React.FC<{
    agent: string;
    size?: 'sm' | 'md' | 'lg';
    working?: boolean;
    className?: string;
}> = ({ agent, size = 'md', working = false, className }) => {
    const Icon = agentIcon(agent);
    const box = size === 'sm' ? 'size-6 rounded-md' : size === 'lg' ? 'size-10 rounded-xl' : 'size-8 rounded-lg';
    const glyph = size === 'sm' ? 'size-3.5' : size === 'lg' ? 'size-5' : 'size-4';

    return (
        <span className={cn('relative inline-flex shrink-0 items-center justify-center border bg-background', box, className)}>
            <Icon className={cn(glyph, 'text-muted-foreground')} aria-hidden />
            {working && (
                <span className="absolute -end-0.5 -top-0.5 flex size-2.5" aria-hidden>
                    <span className="absolute inline-flex size-full animate-ping rounded-full bg-success opacity-60" />
                    <span className="relative inline-flex size-2.5 rounded-full border-2 border-background bg-success" />
                </span>
            )}
        </span>
    );
};
